import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const PublicPanelGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = sessionStorage.getItem('token');

  if (token) {
    router.navigate(['/panel']);
    return false;
  }
  return true;
};
